module.exports = __webpack_public_path__ + "img/antes_despues_252.e95cfd2c.png";